import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import * as _ from 'lodash';
import { takeUntil } from 'rxjs';
import { BaseComponent } from 'src/app/core/components/base/base.component';
import { FeedbackService } from 'src/app/core/services/feedback.service';
import {
  DuplicatePairRow,
  PatientDuplicateMatchService
} from 'src/app/core/services/patient-duplicate-match.service';
import { RENDER_BATCH } from './../../../../shared/directives/render-more.directive';

@Component({
  selector: 'app-duplicate-alert-list',
  templateUrl: './duplicate-alert-list.component.html',
  styleUrls: ['./duplicate-alert-list.component.scss']
})
export class DuplicateAlertListComponent extends BaseComponent implements OnInit, OnChanges {
  /** Rows rendered so far; the rest render as the end of the list nears the screen. */
  shown = RENDER_BATCH;
  readonly renderBatch = RENDER_BATCH;
  @Input() filterValue: string = '';
  @Input() sortBy: 'surname' | 'firstName' | 'patientNumber' = 'surname';
  @Input() sortDirection: 'asc' | 'desc' = 'asc';

  filteredRows: DuplicatePairRow[] = [];
  allRows: DuplicatePairRow[] = [];

  duplicatePairsLoading = false;

  constructor(
    private duplicateMatchService: PatientDuplicateMatchService,
    fs: FeedbackService,
    md: MatDialog
  ) {
    super(fs, md);
  }

  ngOnInit(): void {
    this.duplicateMatchService.duplicatePairsLoading$
      .pipe(takeUntil(this.destroy$))
      .subscribe(loading => {
        this.duplicatePairsLoading = loading;
      });

    this.duplicateMatchService.duplicatePairs$
      .pipe(takeUntil(this.destroy$))
      .subscribe(rows => {
        this.allRows = rows ?? [];
        this.applyFilter();
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filterValue'] || changes['sortBy'] || changes['sortDirection']) {
      this.applyFilter();
    }
  }

  applyFilter(): void {
    this.shown = RENDER_BATCH;
    if (!this.filterValue?.trim()) {
      this.filteredRows = [...this.allRows];
    } else {
      const filterTerms = this.filterValue.toLowerCase().split(/\s+/).filter(Boolean);
      this.filteredRows = this.allRows.filter(row => {
        const blob = [
          row.primaryPatient?.name,
          row.primaryPatient?.surname,
          row.primaryPatient?.patientNumber,
          row.primaryPatient?.diagnosis,
          row.otherPatient?.name,
          row.otherPatient?.surname,
          row.otherPatient?.patientNumber,
          row.otherPatient?.diagnosis,
          row.matchedLabels?.join(' ')
        ]
          .filter(Boolean)
          .join(' ')
          .toLowerCase();
        return filterTerms.every(term => blob.includes(term));
      });
    }
    this.sortRows();
  }

  private sortRows(): void {
    const prop = this.sortBy === 'firstName' ? 'name' : this.sortBy;
    const secondaryProp = prop === 'surname' ? 'name' : 'surname';
    const norm = (v: any) => (v == null ? '' : String(v)).trim().toLowerCase();
    this.filteredRows = _.orderBy(
      this.filteredRows,
      [
        (r: DuplicatePairRow) => norm(r.primaryPatient?.[prop]),
        (r: DuplicatePairRow) => norm(r.primaryPatient?.[secondaryProp])
      ],
      [this.sortDirection, this.sortDirection]
    );
  }
}
